import React from 'react';
import styled from 'styled-components';
import Color from '../../enums/color';
import { getUpperCaseInitials } from '../../helpers/string';
const StyledAvatar = styled.span `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: ${Color.White};
  border: solid 0.8px ${Color.ElectricBlue};
  color: ${Color.ElectricBlue};
  font-family: 'KPMG Web';
  font-weight: 300;
  letter-spacing: 1px;
  text-indent: 1px;
  font-size: 24px;
  border-radius: 50%;
  margin: 0 auto;
`;
const Avatar = ({ names, extractChars = 1 }) => (<StyledAvatar>{getUpperCaseInitials(names, extractChars)}</StyledAvatar>);
export default Avatar;
